import { render, staticRenderFns } from "./Popper-Innova.vue?vue&type=template&id=03b64a52&"
import script from "./Popper-Innova.vue?vue&type=script&lang=js&"
export * from "./Popper-Innova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports